<template>
    <div class="new-certity-result-wrapper">
        <div class="pc-result-main">
            <div class="result-head-con">
                <div class="head-main-con clearfix">
                    <img :src="logo" alt class="fl logo-img-val" />
                    <div class="fl head-title-val">证书/成绩查询系统</div>
                    <div class="fr back-site-btn">
                        <router-link :to="{ name: 'certifyIndex' }"> <i class="wl-icon-fanhui2"></i>返回主站 </router-link>
                    </div>
                </div>
            </div>
            <div class="query-main-con">
                <div class="query-menu-con">
                    <i class="wl-icon-weibiaoti1"></i>
                    <span @click="toHome" class="sp-to-home">首页</span>
                    <span class="sp-lable-line">></span>
                    <span class="sp-active-label">证书查询</span>
                </div>
                <div class="step-main-con">
                    <el-steps :active="activeIndex" class="active-step-con">
                        <el-step title="选择考试项目" icon="wl-icon-kaoshixiangmu"></el-step>
                        <el-step title="输入条件查询" icon="wl-icon-chaxun2"></el-step>
                        <el-step :title="certifyTitle" :icon="typeIcon"></el-step>
                    </el-steps>
                    <div class="step-all-con">
                        <div v-if="activeIndex == 1" class="step-one-con">
                            <div class="step-title-con">
                                <i class="wl-icon-xiaoyuan"></i>
                                选择考试项目
                            </div>
                            <ul class="cerfity-list-ul clearfix">
                                <li class="list-ul-li fl" v-for="(item, index) in cerfityList" :key="index" :class="{ isCanQuery: item.isQuery == '1' }" @click="searchCerfity(item.value, item.isQuery, item.isScoreGrade, item.isCertificateGrade, item.label)">
                                    {{ item.label }}
                                </li>
                            </ul>
                            <div class="p-tip-val">注：灰色背景项目暂不支持查询</div>
                        </div>
                        <div v-if="activeIndex == 2" class="step-one-con">
                            <div class="step-title-con">
                                <i class="wl-icon-xiaoyuan"></i>
                                {{ certifyName }}-输入查询条件
                            </div>
                            <div class="search-form-con">
                                <el-form ref="form" :model="form" label-width="100px" class="form-input-con">
                                    <el-form-item label="报考级别：" prop="level" v-if="(isScoreGrade == 1 && type == 2) || (type == 3 && isScoreGrade == 1)">
                                        <el-select v-model="form.level" placeholder="请选择报考级别">
                                            <el-option v-for="(item, index) in levelOption" :key="index" :label="item.lable" :value="item.value"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <p class="input-tip-val" v-if="type == 3 && certifyId != 'wbkraxarnlxhf8lvk6cumg'">证书编号、姓名、和身份证件号码至少输入两项</p>
                                    <p class="input-tip-val" v-if="type == 3 && certifyId == 'wbkraxarnlxhf8lvk6cumg'">证书编号、姓名</p>
                                    <p class="input-tip-val" v-if="type == 2 && certifyId != 'wbkraxarnlxhf8lvk6cumg'">准考证号、姓名、和身份证件号码至少输入两项</p>
                                    <p class="input-tip-val" v-if="type == 2 && certifyId == 'wbkraxarnlxhf8lvk6cumg'">准考证号、姓名</p>
                                    <el-form-item label="证书编号：" prop="cerfityNum" v-if="type == 3">
                                        <el-input v-model="form.cerfityNum"></el-input>
                                    </el-form-item>
                                    <el-form-item label="准考证号：" prop="ZKZ_ID" v-if="type == 2">
                                        <el-input v-model="form.ZKZ_ID"></el-input>
                                    </el-form-item>
                                    <el-form-item label="姓名：" prop="name">
                                        <el-input v-model="form.name"></el-input>
                                    </el-form-item>

                                    <el-form-item label="身份证号：" prop="IDNuber" v-if="certifyId != 'wbkraxarnlxhf8lvk6cumg'">
                                        <el-input v-model="form.IDNuber"></el-input>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="primary" @click="queryBtn" class="query-result-btn">查询</el-button>
                                        <el-button @click="resetForm()" class="reset-form-btn">重填</el-button>
                                    </el-form-item>
                                </el-form>
                            </div>
                            <div class="guide-search-main">
                                <div class="grade-search-con clearfix">
                                    <div class="fl query-guide-con">
                                        <div class="clearfix">
                                            <div class="icon-head-con head-con-1 fl">
                                                <i class="wl-icon-nanbei"></i>
                                            </div>
                                            <span class="sp-label-title fl">查询指南</span>
                                        </div>
                                        <p class="p-grade-title-1">任意输入以下组合内容即可查询：</p>
                                        <ul class="guide-ul-con" v-if="type == 3 && certifyId != 'wbkraxarnlxhf8lvk6cumg'">
                                            <li>1.身份证号+证书编号</li>
                                            <li>2.身份证号+姓名</li>
                                            <li>3.证书编号+姓名</li>
                                            <li>4.姓名+身份证号+证书编号</li>
                                        </ul>
                                        <ul class="guide-ul-con" v-if="type == 3 && certifyId == 'wbkraxarnlxhf8lvk6cumg'">
                                            <li>1.准考证号+证书编号</li>
                                            <li>2.准考证号+姓名</li>
                                            <li>3.证书编号+姓名</li>
                                            <li>4.姓名+准考证号+证书编号</li>
                                        </ul>
                                        <ul class="guide-ul-con" v-if="type == 2 && certifyId != 'wbkraxarnlxhf8lvk6cumg'">
                                            <li>1.身份证号+准考证号</li>
                                            <li>2.身份证号+姓名</li>
                                            <li>3.准考证号+姓名</li>
                                            <li>4.姓名+身份证号+准考证号</li>
                                        </ul>
                                        <ul class="guide-ul-con" v-if="type == 2 && certifyId == 'wbkraxarnlxhf8lvk6cumg'">
                                            <li>1.准考证号+姓名</li>
                                        </ul>
                                    </div>
                                    <div class="fr care-way-con">
                                        <div class="clearfix">
                                            <div class="icon-head-con head-con-2 fl">
                                                <i class="wl-icon-exclamation"></i>
                                            </div>
                                            <span class="sp-label-title fl">注意事项</span>
                                        </div>
                                        <p class="p-care-con">全国成绩/证书联网查询系统仅限于查询中国物流与采购联合会、北京中物联物流采购培训中心 颁发的物流、采购及供应链相关证书； 数据上传和审核需要一定的时间周期，如急需核实证书真伪，可致电:010-83775917。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="activeIndex == 3" class="step-one-con">
                            <div class="step-title-con">
                                <i class="wl-icon-xiaoyuan"></i>
                                {{ certifyName }}-查询结果
                            </div>
                            <!-- 暂时只展示 物流管理职业技能等级证书 证书模板 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'wbkraxarnlxhf8lvk6cumg'">
                                <canvas class="canvas" width="900px" height="650px" id="canvas"></canvas>
                            </div>

                            <!--  物流管理职业技能等级证书（1+X）师资证书 证书模板 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'l53xabuser1ooa0kfxaya'">
                                <!-- <canvas class="canvas" width="900px" height="650px" id="canvas"></canvas> -->
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUrl == ''">头像未上传，无法生成在线证书，请联系管理员。</p>
                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a>
                            </div>

                            <!--  供应链运营职业技能等级证书（1+X）师资证书 证书模板 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'lran6tolracco2h7z6zq'">
                                <!-- <canvas class="canvas" width="900px" height="650px" id="canvas"></canvas> -->
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUr == ''">头像未上传，无法生成在线证书，请联系管理员。</p>
                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!--  结业证 证书模板 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'gmvapotmzblotynn168gw'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUr == ''">头像未上传，无法生成在线证书，请联系管理员。</p>
                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!--  青年结业证 证书模板 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'rguaafmtq6jfuw0iiiafg'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />

                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUr == ''">头像未上传，无法生成在线证书，请联系管理员。</p>
                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!--  课题申报结业证 证书模板 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'pmgvaceu44nmctfaabxgyg'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />

                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUr == ''">头像未上传，无法生成在线证书，请联系管理员。</p>
                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!-- 全国高校骨干教师“数字供应链发展与供应链专业建设”专项能力提升高级研修班结业证书 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'h0yladouxqrgsv5omdjtq'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />

                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUr == ''">头像未上传，无法生成在线证书，请联系管理员。</p>
                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!-- 职业院校物流专业“双师双证”骨干教师专业技能线上系列培训班结业证书 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'ayjadoubpjcm1sldjaytw'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />

                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUr == ''">头像未上传，无法生成在线证书，请联系管理员。</p>
                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!-- 广西职业技术学院现代物流管理专业现代项目—上海顶实仓储有限公司广州分公司 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'kywvarkveytklrfskrgang'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />

                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUr == ''">头像未上传，无法生成在线证书，请联系管理员。</p>
                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!-- 广西职业技术学院现代物流管理专业现代项目—南宁景通物流有限公司 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'pvosarkvg4fcfev2eocc3a'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />

                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUr == ''">头像未上传，无法生成在线证书，请联系管理员。</p>
                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a>
                            </div>
                            <!-- 叉车设备 -->
                            <div class="canvas-main-con" v-if="type == 3 && certifyId == 'ebiaemv84tkgzwdec8seg'">
                                <img v-if="stuInfo.certificateUrl != ''" class="canvas" width="900px" height="650px" :src="stuInfo.certificateUrl" />

                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <p style="font-size: 18px; color: red" v-if="stuInfo.certificateUr == ''">头像未上传，无法生成在线证书，请联系管理员。</p>
                                <!-- <el-button class="continue-to-btn" @click="downloadCert()">下载证书</el-button> -->
                                <a v-if="stuInfo.certificateUrl != ''" class="continue-to-btn" :href="stuInfo.downloadUrl">下载证书</a>
                            </div>

                            <div class="basic-info-con" v-if="type == 3">
                                <div class="info-head-con">
                                    <i class="wl-icon-jibenxinxi"></i>
                                    <span>基本信息</span>
                                    <span class="small-title-con">/Basic Information</span>
                                </div>
                                <div class="clearfix c-info-main">
                                    <div class="fl c-info-item c-info-item-label">姓名：</div>
                                    <div class="fl c-info-item c-info-item-val">
                                        {{ stuInfo.studentName }}
                                    </div>
                                    <div class="fl c-info-item c-info-item-label">性别：</div>
                                    <div class="fl c-info-item c-info-item-val">
                                        {{ stuInfo.sex === 0 ? "男" : "女" }}
                                    </div>
                                    <div class="fl c-info-item c-info-item-label" v-if="certifyId != 'wbkraxarnlxhf8lvk6cumg'">身份证号：</div>
                                    <div class="fl c-info-item c-info-item-val" v-if="certifyId != 'wbkraxarnlxhf8lvk6cumg'">
                                        {{ stuInfo.idCard }}
                                    </div>
                                    <div class="fl c-info-item c-info-item-label">所在单位：</div>
                                    <div class="fl c-info-item c-info-item-val">
                                        {{ stuInfo.schoolName }}
                                    </div>
                                </div>
                                <div class="info-head-con">
                                    <i class="wl-icon-zhengshu"></i>
                                    <span>证书信息</span>
                                    <span class="small-title-con">/Certificate information</span>
                                </div>
                                <div class="clearfix c-info-main">
                                    <div v-if="certifyId != 'gmvapotmzblotynn168gw' && certifyId != 'rguaafmtq6jfuw0iiiafg' && certifyId != 'pmgvaceu44nmctfaabxgyg'">
                                        <div class="fl c-info-item c-info-item-label">证书等级：</div>
                                        <div class="fl c-info-item c-info-item-val">
                                            {{ stuInfo.examinationGrade }}
                                        </div>
                                    </div>

                                    <div class="fl c-info-item c-info-item-label">证书编号：</div>
                                    <div class="fl c-info-item c-info-item-val">
                                        {{ stuInfo.certificateNum }}
                                    </div>
                                    <div class="fl c-info-item c-info-item-label">发证机构：</div>
                                    <div class="fl c-info-item c-info-item-val" v-if="certifyId == 'wbkraxarnlxhf8lvk6cumg'">北京中物联物流采购培训中心</div>
                                    <div class="fl c-info-item c-info-item-val" v-else>
                                        {{ stuInfo.awardingUnit }}
                                    </div>
                                    <div class="fl c-info-item c-info-item-label">发证日期：</div>
                                    <div class="fl c-info-item c-info-item-val">
                                        {{ stuInfo.dateofIssue }}
                                    </div>
                                </div>
                            </div>

                            <!-- 成绩 -->
                            <el-table :data="gradeList" class="result-table-con" v-if="type == 2">
                                <el-table-column prop="studentName" label="姓名"></el-table-column>
                                <el-table-column prop="idCard" label="身份证号" width="180" v-if="certifyId != 'wbkraxarnlxhf8lvk6cumg'"></el-table-column>
                                <el-table-column prop="siteName" label="考点"></el-table-column>
                                <el-table-column prop="examTime" label="考试时间"></el-table-column>
                                <el-table-column prop="qualifiedState" label="考试结果"></el-table-column>
                                <el-table-column prop="score" label="考试成绩"></el-table-column>
                            </el-table>
                            <div class="continue-to-query">
                                <el-button class="continue-to-btn" @click="continueBtn">继续查询</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer-main-con">
                <p class="p-footer-1">Copyright 2000-2022 in 中国物流与采购联合会、北京中物联物流采购培训中心版权所有</p>
                <a href="https://beian.miit.gov.cn/">京ICP备19032250号-1</a>
            </div>
        </div>
        <!-- 移动端 -->
        <div class="ph-result-main">
            <div class="ph-result-head-mian clearfix">
                <img :src="logo" alt class="fl logo-img-val" />
            </div>
            <div class="ph-nav-con">
                <i class="wl-icon-weibiaoti1"></i>
                <span @click="toHome" class="sp-to-home">首页</span>
                <span class="sp-lable-line">></span>
                <span class="sp-active-label">证书查询</span>
            </div>
            <div class="ph-step-main">
                <el-steps :active="activeIndex" class="active-step-con">
                    <el-step title="选择考试项目" icon="wl-icon-kaoshixiangmu"></el-step>
                    <el-step title="输入条件查询" icon="wl-icon-chaxun2"></el-step>
                    <el-step :title="certifyTitle" :icon="typeIcon"></el-step>
                </el-steps>
            </div>
            <div class="ph-step-all-con">
                <div class="ph-step-one-con ph-step-1" v-if="activeIndex == 1">
                    <div class="step-head-con">
                        <i class="wl-icon-xiaoyuan"></i>
                        选择考试项目
                    </div>
                    <ul class="ph-cerfity-list-ul">
                        <li class="cerfity-li-item" v-for="(item, index) in cerfityList" :key="index" :class="{ isCanQuery: item.isQuery == '1' }" @click="searchCerfity(item.value, item.isQuery, item.isScoreGrade, item.isCertificateGrade, item.label)">
                            {{ item.label }}
                        </li>
                    </ul>
                    <p class="p-notice-con">注：灰色背景项目暂不支持查询</p>
                </div>
                <div class="ph-step-one-con ph-step-2" v-if="activeIndex == 2">
                    <div class="step-head-con">
                        <i class="wl-icon-xiaoyuan"></i>
                        {{ certifyName }}-输入查询条件
                    </div>
                    <div class="ph-search-form-con">
                        <el-form ref="form" :model="form" label-width="85px" class size="small">
                            <el-form-item label="报考级别：" prop="level" v-if="(isScoreGrade == 1 && type == 2) || (type == 3 && isScoreGrade == 1)">
                                <el-select v-model="form.level" placeholder="请选择报考级别">
                                    <el-option v-for="(item, index) in levelOption" :key="index" :label="item.lable" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <p class="input-tip-val" v-if="type == 3 && certifyId != 'wbkraxarnlxhf8lvk6cumg'">证书编号、姓名、和身份证件号码至少输入两项</p>
                            <p class="input-tip-val" v-if="type == 3 && certifyId == 'wbkraxarnlxhf8lvk6cumg'">证书编号、姓名</p>
                            <el-form-item label="证书编号：" prop="cerfityNum" v-if="type == 3">
                                <el-input v-model="form.cerfityNum"></el-input>
                            </el-form-item>
                            <el-form-item label="准考证号：" prop="ZKZ_ID" v-if="type == 2">
                                <el-input v-model="form.ZKZ_ID"></el-input>
                            </el-form-item>
                            <el-form-item label="姓名：" prop="name">
                                <el-input v-model="form.name"></el-input>
                            </el-form-item>
                            <el-form-item label="身份证号：" prop="IDNuber" v-if="certifyId != 'wbkraxarnlxhf8lvk6cumg'">
                                <el-input v-model="form.IDNuber"></el-input>
                            </el-form-item>
                            <p class="input-tip-val" v-if="type == 2 && certifyId != 'wbkraxarnlxhf8lvk6cumg'">准考证号、姓名、和身份证件号码至少输入两项</p>
                            <p class="input-tip-val" v-if="type == 2 && certifyId == 'wbkraxarnlxhf8lvk6cumg'">准考证号、姓名</p>
                            <el-form-item>
                                <el-button type="primary" @click="queryBtn" class="query-result-btn">查询</el-button>
                                <el-button @click="resetForm()" class="reset-form-btn">重填</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="ph-step-one-con ph-step-3" v-if="activeIndex == 3">
                    <div class="step-head-con">
                        <i class="wl-icon-xiaoyuan"></i>
                        {{ certifyName }}-查询结果
                    </div>
                    <div v-if="type == 3 && certifyId == 'wbkraxarnlxhf8lvk6cumg'" class="cerfity-img-con">
                        <img :src="certificate" alt />
                    </div>
                    <div class="basic-info-con" v-if="type == 3 && stuList.length > 0">
                        <div class="info-head-con">
                            <i class="wl-icon-jibenxinxi"></i>
                            <span>基本信息</span>
                            <span class="small-title-con">/Basic Information</span>
                        </div>
                        <div class="clearfix c-info-main">
                            <div class="fl c-info-item c-info-item-label">姓名：</div>
                            <div class="fl c-info-item c-info-item-val">
                                {{ stuList[0].studentName }}
                            </div>
                            <!-- <div class="fl c-info-item c-info-item-label">性别：</div>
                            <div class="fl c-info-item c-info-item-val">{{ stuInfo.sex === 0 ? "男" : "女" }}</div> -->
                            <div class="fl c-info-item c-info-item-label" v-if="certifyId != 'wbkraxarnlxhf8lvk6cumg'">身份证号：</div>
                            <div class="fl c-info-item c-info-item-val" v-if="certifyId != 'wbkraxarnlxhf8lvk6cumg'">
                                {{ stuList[0].idCard }}
                            </div>
                            <div class="fl c-info-item c-info-item-label">所在单位：</div>
                            <div class="fl c-info-item c-info-item-val">
                                {{ stuList[0].schoolName }}
                            </div>
                            <div class="fl c-info-item c-info-item-label">参训名称：</div>
                            <div class="fl c-info-item c-info-item-val">
                                {{ stuList[0].peixunName }}
                            </div>
                            <div class="fl c-info-item c-info-item-label">参训时间：</div>
                            <div class="fl c-info-item c-info-item-val">
                                {{ stuList[0].peixunTime }}
                            </div>
                            <div class="fl c-info-item c-info-item-label" style="height: 200px">照片：</div>
                            <div class="fl c-info-item c-info-item-val" style="height: 200px">
                                <img :src="stuList[0].studentUrl" class="c-student-img" />
                            </div>
                        </div>
                        <div v-for="(item, index) in stuList" :key="index">
                            <div class="info-head-con">
                                <i class="wl-icon-zhengshu"></i>
                                <span>证书信息</span>
                                <span class="small-title-con">/Certificate information</span>
                            </div>
                            <div class="clearfix c-info-main">
                                <div class="fl c-info-item c-info-item-label">证书类型：</div>
                                <div class="fl c-info-item c-info-item-val">
                                    {{ item.certificateType }}
                                </div>
                                <div class="fl c-info-item c-info-item-label">证书等级：</div>
                                <div class="fl c-info-item c-info-item-val">
                                    {{ item.examinationGrade }}
                                </div>
                                <div class="fl c-info-item c-info-item-label">证书编号：</div>
                                <div class="fl c-info-item c-info-item-val">
                                    {{ item.certificateNum }}
                                </div>
                                <div class="fl c-info-item c-info-item-label">颁证单位：</div>
                                <div class="fl c-info-item c-info-item-val" v-if="certifyId == 'wbkraxarnlxhf8lvk6cumg'">北京中物联物流采购培训中心</div>
                                <div class="fl c-info-item c-info-item-val" v-else>
                                    {{ item.awardingUnit }}
                                </div>
                                <div class="fl c-info-item c-info-item-label">颁证日期：</div>
                                <div class="fl c-info-item c-info-item-val">
                                    {{ item.dateofIssue }}
                                </div>
                                <div class="fl c-info-item c-info-item-label">有效期(x年)：</div>
                                <div class="fl c-info-item c-info-item-val">
                                    {{ item.effectiveTime }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="result-table-main">
                        <el-table :data="gradeList" class="result-table-con" v-if="type == 2" size="small">
                            <el-table-column fixed prop="studentName" label="姓名"></el-table-column>
                            <el-table-column prop="idCard" label="身份证号" width="180" v-if="certifyId != 'wbkraxarnlxhf8lvk6cumg'"></el-table-column>
                            <el-table-column prop="siteName" label="考点"></el-table-column>
                            <el-table-column prop="examTime" label="考试时间"></el-table-column>
                            <el-table-column prop="qualifiedState" label="考试结果"></el-table-column>
                            <el-table-column prop="score" label="考试成绩"></el-table-column>
                        </el-table>
                    </div>
                    <div class="continue-to-query">
                        <el-button class="continue-to-btn" size="small" @click="continueBtn">继续查询</el-button>
                    </div>
                </div>
            </div>
            <div class="footer-main-con">
                <p class="p-footer-1">
                    Copyright 2000-2022
                    <a href="https://beian.miit.gov.cn/">京ICP备19032250号-1</a>
                </p>
                <p>中国物流与采购联合会、北京中物联物流采购培训中心版权所有</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            certificateZXJYZ: require("assets/images/zxpxjyzh.jpg"),
            certificateJYZ: require("assets/images/certificateJYZ.jpg"),
            certificateQNJYZ: require("assets/images/qnjyz.jpg"),
            userActive: require("assets/images/person.png"),
            logo: require("assets/images/ce-qeury-logo.png"),
            activeIndex: 1,
            cerfityList: [],
            form: {
                level: "",
                cerfityNum: "",
                name: "",
                IDNuber: "",
                ZKZ_ID: "",
            },
            levelOption: [],
            certifyId: "",
            certifyName: "",
            isScoreGrade: "",
            isCertificateGrade: "",
            stuInfo: {},
            stuList: [],
            certificate: require("assets/images/certificate.png"),
            certificateWL: require("assets/images/certificateWL.jpg"), //物流管理
            certificateGYL: require("assets/images/certificateGYL.jpg"), //供应链运营
            dateMoth: ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"],
            dateGradeEnglish: [
                {
                    value: "物流员（仓储与配送）",
                    label: "Basic level(Warehousing&Distribution)",
                },
                {
                    value: "物流员（货物运输）",
                    label: "Basic level(Transport of goods)",
                },
                {
                    value: "助理级",
                    label: "Junior Level",
                },
                {
                    value: "初级",
                    label: "Primary Level",
                },
                {
                    value: "中级",
                    label: "Middle Level",
                },
                {
                    value: "高级",
                    label: "Senior Level",
                },
                {
                    value: "见习中级",
                    label: "Middle Level (Intern)",
                },
                // {
                //     value: "中级",
                //     label: "Middle Level.",
                // },
                // {
                //     value: "高级",
                //     label: "Senior Level.",
                // },
                {
                    value: "注册级",
                    label: "Registered  Level",
                },
            ],
            certifyUrl: "",
            certifyTitle: "",
            gradeList: [],
            typeIcon: "",
        };
    },
    props: {
        // 1 证书 2 成绩
        type: {
            type: [Number, String],
            default: "",
        },
    },
    created() {
        this.getCerfityList();
        this.certifyTitle = this.type == 3 ? "查看证书" : "查看成绩";
        this.typeIcon = this.type == 3 ? "wl-icon-zhengshu1" : "wl-icon-xuexichengji";
    },
    methods: {
        continueBtn() {
            this.activeIndex = 1;
            this.resetForm();
        },
        searchCerfity(id, isQuery, isScoreGrade, isCertificateGrade, label) {
            if (isQuery == "1") {
                return this.$message.warning("暂不可查询!");
            }
            this.certifyId = id;
            this.activeIndex = 2;
            this.isScoreGrade = isScoreGrade;
            this.isCertificateGrade = isCertificateGrade;
            this.certifyName = label;
            this.$http
                .post("/api/XOrg/CertGradeMgr/getCertificateGrade", {
                    typeId: id,
                })
                .then((res) => {
                    if (res.code > 0) {
                        this.levelOption = res.list;
                    } else {
                        return;
                    }
                });
        },
        resetForm() {
            this.form.level = "";
            this.form.cerfityNum = "";
            this.form.name = "";
            this.form.IDNuber = "";
            this.form.ZKZ_ID = "";
            // this.$refs[formName].resetFields();
        },
        queryBtn() {
            var that = this;
            // 证书查询
            if (this.type == 3) {
                this.$http
                    .post("/api/XOrg/CertificateManager/getCertificateInfoList", {
                        //getCertificateInfoList
                        name: this.form.name,
                        IDNum: this.form.IDNuber,
                        cerfityNum: this.form.cerfityNum,
                        ExaminationGradeId: this.form.level,
                        CertificateTypeId: this.certifyId,
                    })
                    .then((res) => {
                        if (res.code > 0) {
                            that.stuInfo = res.info;
                            that.peixunTime = res.peixunTime;
                            that.peixunTimeMonths = res.peixunTimeMonths;
                            that.peixunTimeMonthsa = res.peixunTimeMonthsa;
                            that.activeIndex = 3;
                            if (that.certifyId == "wbkraxarnlxhf8lvk6cumg") {
                                that.$nextTick(() => {
                                    that.getCanvas();
                                });
                            } else if (that.certifyId == "l53xabuser1ooa0kfxaya" && res.info.peixunTimeYear > 2020) {
                                //物流管理
                                that.$nextTick(() => {
                                    that.getCanvasWL();
                                });
                            } else if (that.certifyId == "lran6tolracco2h7z6zq" && res.info.peixunTimeYear > 2020) {
                                //供应链运营
                                that.$nextTick(() => {
                                    that.getCanvasGYL();
                                });
                            } else if (that.certifyId == "gmvapotmzblotynn168gw") {
                                //结业证
                                that.$nextTick(() => {
                                    that.getCanvasJYZ();
                                });
                            } else if (that.certifyId == "rguaafmtq6jfuw0iiiafg") {
                                //结业证
                                that.$nextTick(() => {
                                    that.getCanvasQNJYZ();
                                });
                            } else if (that.certifyId == "pmgvaceu44nmctfaabxgyg") {
                                //结业证
                                that.$nextTick(() => {
                                    that.getCanvasZXJYZ();
                                });
                            }
                        } else {
                            return this.$message.warning(res.msg);
                        }
                    });
            }
            if (this.type == 2) {
                this.$http
                    .post("/api/XOrg/ResultsManager/getStudentResultList", {
                        studentName: this.form.name,
                        idCard: this.form.IDNuber,
                        ExaminationGradeId: this.form.level,
                        CertificateTypeId: this.certifyId,
                        ZKZ_ID: this.form.ZKZ_ID,
                    })
                    .then((res) => {
                        if (res.code > 0) {
                            that.gradeList = res.list;
                            that.activeIndex = 3;
                        } else {
                            return this.$message.warning(res.msg);
                        }
                    });
            }
        },
        getCanvas() {
            var canvas = document.getElementById("canvas");
            console.log(canvas);
            var ctx = canvas.getContext("2d");
            // 绘制背景图
            var image1 = new Image();
            image1.src = this.certificate;
            var promise1 = new Promise((resolve, reject) => {
                image1.onload = function () {
                    ctx.drawImage(image1, 0, 0, 900, 650);
                    resolve("ok");
                };
            });
            promise1
                .then((res) => {
                    if (res == "ok") {
                        // 学生姓名
                        ctx.font = "14px Arial"; //宋体
                        ctx.fillStyle = "#1c1417";
                        ctx.fillText(`${this.stuInfo.studentName}`, 730, 340);
                        ctx.stroke();
                        // 学生姓名（拼音）
                        ctx.font = "14px Arial";
                        ctx.fillStyle = "#1c1417";
                        ctx.fillText(`${this.stuInfo.studentNamePinyin}`, 710, 370);
                        ctx.stroke();
                        // 参加物流考试时间
                        ctx.font = "16px Source Han Sans CN";
                        ctx.fillStyle = "#1c1417";
                        ctx.fillText(`${this.stuInfo.examTime}`, 145, 198);
                        // 级别（初级 中级 高级）
                        ctx.font = "16px Source Han Sans CN";
                        ctx.fillStyle = "#1c1417";
                        ctx.fillText(`${this.stuInfo.examinationGrade}`, 359, 228);
                        // 参加物流考试的时间（英文）
                        ctx.font = "italic 12px Arial";
                        ctx.fillStyle = "#1c1417";
                        ctx.fillText(`in ${this.stuInfo.examYMEnglish}`, 555, 285);
                        // 级别（初级 中级 高级）（英文）
                        ctx.font = "italic 12px Arial";
                        ctx.fillStyle = "#1c1417";
                        ctx.fillText(`${this.stuInfo.examinationGradeEnglish}`, 242, 313);
                        // 身份证
                        ctx.font = "16px Source Han Sans CN";
                        ctx.fillStyle = "#1c1417";
                        ctx.fillText(`${this.stuInfo.idCard}`, 230, 380);
                        // 证书编号
                        ctx.font = "16px Source Han Sans CN";
                        ctx.fillStyle = "#1c1417";
                        ctx.fillText(`${this.stuInfo.certificateNum}`, 230, 420);
                        // 发放证书时间
                        ctx.font = "16px Source Han Sans CN";
                        ctx.fillStyle = "#1c1417";
                        ctx.fillText(`${this.stuInfo.dateofIssue}`, 230, 505);
                        var image = new Image();
                        image.setAttribute("crossOrigin", "Anonymous");
                        image.src = this.stuInfo.studentUrl;
                        image.onload = () => {
                            ctx.drawImage(image, 698, 190, 100, 130);
                            this.certifyUrl = canvas.toDataURL("image/jpeg");
                            console.log(this.certifyUrl);
                        };
                    }
                })
                .catch((err) => {});
        },
        getCanvasWL() {
            var canvas = document.getElementById("canvas");
            console.log(canvas);
            var ctx = canvas.getContext("2d");
            // 绘制背景图
            var image1 = new Image();
            image1.src = this.certificateWL;
            var promise1 = new Promise((resolve, reject) => {
                image1.onload = function () {
                    ctx.drawImage(image1, 0, 0, 900, 650);
                    resolve("ok");
                };
            });
            promise1.then((res) => {
                if (res == "ok") {
                    //考生照片
                    var promise2 = new Promise((r1, r2) => {
                        var img = new Image();
                        img.crossOrigin = "*";

                        img.src = this.stuInfo.studentUrl + "?v=" + Math.random();

                        img.onload = function () {
                            //ctx.drawImage(img, 412, 350, 95, 130);
                            ctx.drawImage(img, 210, 180, 95, 130);
                        };
                    });

                    // 上部年左
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(0, 4)}`, 546, 160);
                    // 上部年右
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(11, 15)}`, 685, 160);
                    // 中部年左
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeYearFZx}`, 468, 305);
                    // 中部年右
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeYearFZy}`, 620, 305);

                    // 下部年
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeYearFZ}`, 630, 525);

                    // 上部月左
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(5, 7)}`, 596, 160);
                    // 上部月右
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(16, 18)}`, 732, 160);
                    // 中部月左
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeMonthFZx}`, 520, 305);
                    // 中部月右
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeMonthFZy}`, 670, 305);
                    // 下部月
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeMonthFZ}`, 695, 525);

                    // 上部日左
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(8, 10)}`, 630, 160);
                    // 上部日右
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(19, 21)}`, 767, 160);
                    // 中部日左
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeDayFZx}`, 560, 305);
                    // 中部日右
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeDayFZy}`, 710, 305);
                    // 下部日
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeDayFZ}`, 735, 525);

                    //英文日期发证时间
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.dateMoth[this.stuInfo.examTimeMonths]} ${this.stuInfo.examTimeDayFZ} ${this.stuInfo.examTimeYearFZ}`, 675, 545);

                    //英文日期培训时间开始
                    ctx.font = "12px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.dateMoth[this.peixunTimeMonths]} ${this.peixunTime.slice(8, 10)}`, 710, 368);

                    //英文日期培训时间结束
                    ctx.font = "12px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.dateMoth[this.peixunTimeMonthsa]} ${this.peixunTime.slice(19, 21)} ${this.stuInfo.examTimeYearFZa}`, 440, 385);

                    //英文日期聘期开始时间
                    ctx.font = "12px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.dateMoth[this.stuInfo.examTimeMonthsb]} ${this.stuInfo.examTimeDayFZb} ${this.stuInfo.examTimeYearFZb}`, 720, 418);

                    //英文日期聘期结束时间
                    ctx.font = "12px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.dateMoth[this.stuInfo.examTimeMonthsc]} ${this.stuInfo.examTimeDayFZc} ${this.stuInfo.examTimeYearFZc}`, 440, 435);

                    //学生姓名
                    ctx.font = "14px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.studentName}`, 450, 160);
                    ctx.stroke();
                    // 学生姓名（拼音）
                    ctx.font = "12px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.studentNamePinyin}`, 583, 332);
                    ctx.stroke();

                    // 身份证
                    ctx.font = "13px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.idCard}`, 220, 452);
                    // 证书编号
                    ctx.font = "13px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.certificateNum}`, 220, 495);

                    // 学时上
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.studyTime}`, 580, 230);
                    //学时下
                    ctx.font = "12px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.studyTimex}`, 600, 385);

                    // 级别（初级 中级 高级）
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examinationGrade}`, 470, 230);

                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examinationGradex}`, 730, 270);

                    //级别（初级 中级 高级）（英文）
                    ctx.font = "12px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    let str = this.dateGradeEnglish.find((item, index) => {
                        return item.value === this.stuInfo.examinationGrade;
                    });
                    ctx.fillText(`${str.label}`, 550, 368);

                    ctx.font = "12px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    let strx = this.dateGradeEnglish.find((item, index) => {
                        return item.value === this.stuInfo.examinationGradex;
                    });
                    ctx.fillText(`${strx.label}`, 600, 418);
                }
            });
        },
        getCanvasGYL() {
            var canvas = document.getElementById("canvas");
            console.log(canvas);
            var ctx = canvas.getContext("2d");
            // 绘制背景图
            var image1 = new Image();
            image1.src = this.certificateGYL;
            var promise1 = new Promise((resolve, reject) => {
                image1.onload = function () {
                    ctx.drawImage(image1, 0, 0, 900, 650);
                    resolve("ok");
                };
            });
            promise1.then((res) => {
                if (res == "ok") {
                    //考生照片
                    var promise2 = new Promise((r1, r2) => {
                        var img = new Image();
                        img.crossOrigin = "*";

                        img.src = this.stuInfo.studentUrl + "?v=" + Math.random();

                        img.onload = function () {
                            //ctx.drawImage(img, 412, 350, 95, 130);
                            ctx.drawImage(img, 210, 180, 95, 130);
                        };
                    });

                    // 上部年左
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(0, 4)}`, 540, 160);
                    // 上部年右
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(11, 15)}`, 681, 160);
                    // 中部年左
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeYearFZx}`, 700, 270);
                    // 中部年右
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeYearFZy}`, 497, 305);

                    // 下部年
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeYearFZ}`, 630, 525);

                    // 上部月左
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(5, 7)}`, 592, 160);
                    // 上部月右
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(16, 18)}`, 730, 160);
                    // 中部月左
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeMonthFZx}`, 770, 270);
                    // 中部月右
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeMonthFZy}`, 550, 305);
                    // 下部月
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeMonthFZ}`, 692, 525);

                    // 上部日左
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(8, 10)}`, 628, 160);
                    // 上部日右
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.peixunTime.slice(19, 21)}`, 766, 160);
                    // 中部日左
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeDayFZx}`, 437, 305);
                    // 中部日右
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeDayFZy}`, 591, 305);
                    // 下部日
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeDayFZ}`, 732, 525);

                    //英文日期发证时间
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.dateMoth[this.stuInfo.examTimeMonths]} ${this.stuInfo.examTimeDayFZ} ${this.stuInfo.examTimeYearFZ}`, 675, 545);

                    //英文日期培训时间开始
                    ctx.font = "12px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.dateMoth[this.peixunTimeMonths]} ${this.peixunTime.slice(8, 10)}`, 580, 368);

                    //英文日期培训时间结束
                    ctx.font = "12px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.dateMoth[this.peixunTimeMonthsa]} ${this.peixunTime.slice(19, 21)} ${this.stuInfo.examTimeYearFZa}`, 710, 368);

                    //英文日期聘期开始时间
                    ctx.font = "12px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.dateMoth[this.stuInfo.examTimeMonthsb]} ${this.stuInfo.examTimeDayFZb} ${this.stuInfo.examTimeYearFZb}`, 475, 418);

                    //英文日期聘期结束时间
                    ctx.font = "12px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.dateMoth[this.stuInfo.examTimeMonthsc]} ${this.stuInfo.examTimeDayFZc} ${this.stuInfo.examTimeYearFZc}`, 610, 418);

                    //学生姓名
                    ctx.font = "14px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.studentName}`, 458, 160);
                    ctx.stroke();
                    // 学生姓名（拼音）
                    ctx.font = "12px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.studentNamePinyin}`, 570, 332);
                    ctx.stroke();

                    // 身份证
                    ctx.font = "13px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.idCard}`, 220, 452);
                    // 证书编号
                    ctx.font = "13px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.certificateNum}`, 220, 495);

                    // 学时上
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.studyTimeg}`, 520, 230);
                    //学时下
                    ctx.font = "12px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.studyTimegx}`, 465, 385);

                    // 级别（初级 中级 高级）
                    // ctx.font = "14px  HYDaSongJ";
                    // ctx.fillStyle = "#1c1417";
                    // ctx.fillText(`${this.stuInfo.examinationGrade}`, 480, 230);

                    // ctx.font = "14px  HYDaSongJ";
                    // ctx.fillStyle = "#1c1417";
                    // ctx.fillText(`${this.stuInfo.examinationGradex}`, 745, 268);

                    //级别（初级 中级 高级）（英文）
                    // ctx.font = "12px HYDaSongJ";
                    // ctx.fillStyle = "#1c1417";
                    // let str = this.dateGradeEnglish.find((item, index) => {
                    //     return item.value === this.stuInfo.examinationGrade;
                    // });
                    // ctx.fillText(`${str.label}`, 550, 368);

                    // ctx.font = "12px HYDaSongJ";
                    // ctx.fillStyle = "#1c1417";
                    // let strx = this.dateGradeEnglish.find((item,index)=>{
                    //     return item.value === this.stuInfo.examinationGradex
                    // })
                    // ctx.fillText(`${strx.label}`, 540, 418);
                }
            });
        },
        getCanvasJYZ() {
            var canvas = document.getElementById("canvas");
            console.log(canvas);
            var ctx = canvas.getContext("2d");
            // 绘制背景图
            var image1 = new Image();
            image1.src = this.certificateJYZ;
            var promise1 = new Promise((resolve, reject) => {
                image1.onload = function () {
                    ctx.drawImage(image1, 0, 0, 900, 650);
                    resolve("ok");
                };
            });
            promise1.then((res) => {
                if (res == "ok") {
                    //考生照片
                    var promise2 = new Promise((r1, r2) => {
                        var img = new Image();
                        img.crossOrigin = "*";

                        img.src = this.stuInfo.studentUrl + "?v=" + Math.random();
                        // img.src = this.person;

                        img.onload = function () {
                            //ctx.drawImage(img, 412, 350, 95, 130);
                            ctx.drawImage(img, 180, 260, 120, 160);
                        };
                    });
                    console.log(this.stuInfo);
                    //学生姓名
                    ctx.font = "14px HYDaSongJ";
                    ctx.fillStyle = "#000";
                    ctx.fillText(`${this.stuInfo.studentName}`, 430, 295);
                    ctx.stroke();
                    // 年
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(0, 4)}`, 493, 295);
                    // 月
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(5, 7)}`, 545, 295);
                    // 日
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(8, 10)}`, 582, 295);
                    // 年
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(11, 15)}`, 635, 295);
                    // 月
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(16, 18)}`, 686, 295);
                    // 日
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(19, 21)}`, 723, 295);

                    // 下部日
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeDayFZ}`, 728, 520);

                    // 下部年
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeYearFZ}`, 635, 520);

                    // 下部月
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeMonthFZ}`, 693, 520);

                    // 学时上
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText("24", 506, 379);

                    // 身份证
                    ctx.font = "13px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.idCard}`, 208, 465);
                    // 证书编号
                    ctx.font = "13px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.certificateNum}`, 208, 503);
                }
            });
        },
        getCanvasQNJYZ() {
            var canvas = document.getElementById("canvas");
            console.log(canvas);
            var ctx = canvas.getContext("2d");
            // 绘制背景图
            var image1 = new Image();
            image1.src = this.certificateQNJYZ;
            var promise1 = new Promise((resolve, reject) => {
                image1.onload = function () {
                    ctx.drawImage(image1, 0, 0, 900, 650);
                    resolve("ok");
                };
            });
            promise1.then((res) => {
                if (res == "ok") {
                    //考生照片
                    var promise2 = new Promise((r1, r2) => {
                        var img = new Image();
                        img.crossOrigin = "*";

                        img.src = this.stuInfo.studentUrl + "?v=" + Math.random();
                        // img.src = this.person;

                        img.onload = function () {
                            //ctx.drawImage(img, 412, 350, 95, 130);
                            ctx.drawImage(img, 180, 260, 120, 160);
                        };
                    });
                    console.log(this.stuInfo);
                    //学生姓名
                    ctx.font = "14px HYDaSongJ";
                    ctx.fillStyle = "#000";
                    ctx.fillText(`${this.stuInfo.studentName}`, 430, 295);
                    ctx.stroke();
                    // 年
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(0, 4)}`, 493, 295);
                    // 月
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(5, 7)}`, 545, 295);
                    // 日
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(8, 10)}`, 582, 295);
                    // 年
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(11, 15)}`, 635, 295);
                    // 月
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(16, 18)}`, 686, 295);
                    // 日
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(19, 21)}`, 723, 295);

                    // 下部日
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeDayFZ}`, 728, 520);

                    // 下部年
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeYearFZ}`, 635, 520);

                    // 下部月
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeMonthFZ}`, 693, 520);

                    // 学时上
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText("24", 428, 378);

                    // 身份证
                    ctx.font = "13px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.idCard}`, 208, 465);
                    // 证书编号
                    ctx.font = "13px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.certificateNum}`, 208, 503);
                }
            });
        },
        getCanvasZXJYZ() {
            var canvas = document.getElementById("canvas");
            console.log(canvas);
            var ctx = canvas.getContext("2d");
            // 绘制背景图
            var image1 = new Image();
            image1.src = this.certificateZXJYZ;
            var promise1 = new Promise((resolve, reject) => {
                image1.onload = function () {
                    ctx.drawImage(image1, 0, 0, 900, 650);
                    resolve("ok");
                };
            });
            promise1.then((res) => {
                if (res == "ok") {
                    //考生照片
                    var promise2 = new Promise((r1, r2) => {
                        var img = new Image();
                        img.crossOrigin = "*";

                        img.src = this.stuInfo.studentUrl + "?v=" + Math.random();
                        // img.src = this.person;

                        img.onload = function () {
                            //ctx.drawImage(img, 412, 350, 95, 130);
                            ctx.drawImage(img, 180, 260, 120, 160);
                        };
                    });
                    console.log(this.stuInfo);
                    //学生姓名
                    ctx.font = "14px HYDaSongJ";
                    ctx.fillStyle = "#000";
                    ctx.fillText(`${this.stuInfo.studentName}`, 430, 295);
                    ctx.stroke();
                    // 年
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(0, 4)}`, 493, 295);
                    // 月
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(5, 7)}`, 545, 295);
                    // 日
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(8, 10)}`, 582, 295);
                    // 年
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(11, 15)}`, 635, 295);
                    // 月
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(16, 18)}`, 686, 295);
                    // 日
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.peixunTime.slice(19, 21)}`, 723, 295);

                    // 下部日
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeDayFZ}`, 728, 520);

                    // 下部年
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeYearFZ}`, 635, 520);

                    // 下部月
                    ctx.font = "15px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.examTimeMonthFZ}`, 693, 520);

                    // 学时上
                    ctx.font = "14px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText("16", 475, 378);

                    // 身份证
                    ctx.font = "13px  HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.idCard}`, 208, 465);
                    // 证书编号
                    ctx.font = "13px HYDaSongJ";
                    ctx.fillStyle = "#1c1417";
                    ctx.fillText(`${this.stuInfo.certificateNum}`, 208, 503);
                }
            });
        },
        downloadCert() {
            var canvas = document.getElementById("canvas");
            var url = canvas.toDataURL("image/png");
            var oA = document.createElement("a");
            oA.download = this.stuInfo.studentName; // 设置下载的文件名，默认是'下载'
            oA.href = url;
            document.body.appendChild(oA);
            oA.click();
            oA.remove(); // 下载之后把创建的元素删除
        },
        getCerfityList() {
            this.$http
                .post("/api/XOrg/CertificateTypeManager/getCertificateType", {
                    isShowScore: this.type == 2 ? 1 : 0,
                    isShowCertificate: this.type == 3 ? 1 : 0,
                    type: 1,
                })
                .then((res) => {
                    if (res.code > 0) {
                        this.cerfityList = res.list;
                    } else {
                        return;
                    }
                });
        },
        toHome() {
            this.$router.push({
                name: "certifyIndex",
            });
        },
    },
};
</script>

<style lang="scss"></style>
